import EmailService from '../../services/email.service'

export const emails = {
  namespaced: true,
  actions: {
    subscribe ({ commit }, email) {
      return EmailService.subscribe(email).then(
        data => {
          commit('subscribeSuccess', data)
          return Promise.resolve(data)
        },
        error => {
          commit('subscribeFailure')
          return Promise.reject(error)
        },
      )
    },
    sendEmail ({ commit }, emailObj) {
      console.log(emailObj)
      return EmailService.sendEmail(
        emailObj.email,
        emailObj.name,
        emailObj.subject,
        emailObj.content,
      ).then(
        data => {
          commit('sendEmailSuccess', data)
          return Promise.resolve(data)
        },
        error => {
          commit('sendEmailFailure')
          return Promise.reject(error)
        },
      )
    },
  },
  mutations: {
    subscribeSuccess (state, email) {
      state.emailNl = email
    },
    subscribeFailure (state, email) {
      state.emailNl = null
    },
     sendEmailSuccess (state, email) {
      state.emailSent = email
    },
    sendEmailFailure (state, email) {
      state.emailSent = null
    },
  },
}
